// packages/api-client/queries/contestsEditionsStages/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createContestsEditionsStagesQueries = (requests, queryClient) => ({
    useGetStageLiveStats: (params, options = {}) => useQuery({
        queryKey: ["contests-editions-stage-live-stats", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.getStageLiveStats(params);
        },
        ...options,
    }),
    useCreateContestsEditionsStage: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageAttrs) => {
            return requests.createContestsEditionStage(contestsEditionsStageAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useDeleteContestsEditionsStage: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageId) => {
            return requests.deleteContestsEditionStage(contestsEditionsStageId);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useListContestsEditionsStages: (params, options = {}) => useQuery({
        queryKey: ["contests-editions-stages", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContestsEditionStages(params);
        },
        ...options,
    }),
    useGetContestsEditionsStage: (params, options = {}) => useQuery({
        queryKey: ["contests-editions-stage", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findContestsEditionStage(params);
        },
        ...options,
    }),
    useStartContestsEditionsStage: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageAttrs) => {
            return requests.startContestsEditionStage(contestsEditionsStageAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useStopContestsEditionsStage: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageAttrs) => {
            return requests.stopContestsEditionStage(contestsEditionsStageAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useUpdateContestsEditionsStage: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageAttrs) => {
            return requests.updateContestsEditionStage(contestsEditionsStageAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            options.onSuccess?.(...args);
        },
    }),
    useAutoAssignContestsEditionsStagesTables: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStageAttrs) => {
            return requests.autoAssignContestsEditionStageTables(contestsEditionsStageAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-stages"],
            });
            options.onSuccess?.(...args);
        },
    }),
});
//# sourceMappingURL=index.js.map